// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__joTPK","defaultLogo":"Nav_defaultLogo__zJBlj","shopLogo":"Nav_shopLogo__LpFgj","centerContent":"Nav_centerContent__GA+hF","hiddenMobile":"Nav_hiddenMobile__a3-gc"};